import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { PickingOrderStrategy } from 'shared/printing/pickingOrder';

interface PickingOrderSettings {
  strategy: PickingOrderStrategy;
}

export const pickingOrderEndpoints = (
  builder: EndpointBuilder<any, any, any>,
) => ({
  getPickingOrderSettings: builder.query<PickingOrderSettings, void>({
    query: () => `/picking-order-settings/`,
  }),
});
